import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants/enums";
import { FeedInsertSettings } from "../../content.types";

export const requestFeedInsertsSettings =
  async (): Promise<FeedInsertSettings> => {
    return await instance.get(ApiRoutesContent.FeedInsertsSettings);
  };
